import { render, staticRenderFns } from "./GlobalNotification.vue?vue&type=template&id=3d88d5ea&"
import script from "./GlobalNotification.vue?vue&type=script&lang=js&"
export * from "./GlobalNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports